import { useDeleteCvletter } from "http-hooks/cvletter/useCvletter";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteCvletter({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteCvletter();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Covering Letter"
      description="Are you sure you want to delete this covering letter? This covering letter will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
